import productUnavailable from '@/assets/product-unavailable.jpg';

type ProductUnavailableCardProps = {
	tradeName: string;
	productId: string;
};

const B2BProductUnavailableCard = ({
	tradeName,
	productId,
}: ProductUnavailableCardProps) => {
	return (
		<div
			className="flex flex-col justify-between"
			data-test="product-unavailadble-card"
		>
			<div className="relative">
				<div className="relative h-72 w-full overflow-hidden rounded-lg">
					<img
						alt={tradeName}
						src={productUnavailable}
						className="h-full w-full object-cover object-center"
						data-test="product-unavailable-image"
					/>
				</div>
				<div className="relative mt-4">
					<h3 className="text-sm font-medium text-gray-900">
						Product unavailable
					</h3>
					<p className="mt-1 text-sm text-gray-500">{`Store: ${tradeName}`}</p>
				</div>
				<div className="absolute inset-x-0 top-0 flex h-72 items-end justify-end overflow-hidden rounded-lg p-4">
					<div
						aria-hidden="true"
						className="absolute inset-x-0 bottom-0 h-36 bg-gradient-to-t from-black opacity-50"
					/>
					<p className="relative text-lg font-semibold text-white">
						{`ID:${productId}`}
					</p>
				</div>
			</div>
		</div>
	);
};

export default B2BProductUnavailableCard;
